import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "#FFF"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H20a1 1 0 0 1 1\n      1v3h-2V7h-7.414l-2-2H4v11.998L5.5 11h17l-2.31 9.243a1 1 0 0\n      1-.97.757H3zm16.938-8H7.062l-1.5 6h12.876l1.5-6z" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      id: "filebtn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openFile && _ctx.openFile(...args)))
    }, [
      _hoisted_1,
      _createTextVNode(" Load watch history ")
    ]),
    _createElementVNode("input", {
      id: "file",
      ref: "file",
      type: "file",
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
    }, null, 544)
  ]))
}